var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInactiveInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1428 11.2859V5.28587L6.85706 1.00015H2.57134C2.11668 1.00015 1.68065 1.18076 1.35916 1.50226C1.03767 1.82375 0.857056 2.25978 0.857056 2.71444V11.2859C0.857056 11.7405 1.03767 12.1766 1.35916 12.498C1.68065 12.8195 2.11668 13.0002 2.57134 13.0002H9.42848C9.88314 13.0002 10.3192 12.8195 10.6407 12.498C10.9622 12.1766 11.1428 11.7405 11.1428 11.2859V11.2859Z",
    stroke: "#595959",
    strokeWidth: 1.38107,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85693 1.00021V3.57164C6.85693 4.0263 7.03755 4.46233 7.35904 4.78383C7.68053 5.10532 8.11656 5.28593 8.57122 5.28593H11.1426",
    stroke: "#595959",
    strokeWidth: 1.38107,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInactiveInvoice);
export default __webpack_public_path__ + "static/media/iconInactive-invoice.0ab2d2a4de6fc0a7a3a335346dfabbb3.svg";
export { ForwardRef as ReactComponent };